import React, { Component } from "react";
import { Col, Layout, Row, Table, Tag } from "antd";
import { connect } from "react-redux";
import Moment from "moment";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import {
  DATA_QUERY,
  getRawLogs,
  getGatewayList,
  MAPKEY_FORM_VALUE,
} from "./service";
import SearchRawForm from "./search-form";
import column from "./column";
import { Constant } from "../../config";

const { Content } = Layout;
Moment.globalLocal = false;

class SlRawLog extends Component {
  state = {
    gatewayList: [],
    smsGatewayList: [],
    viberGatewayList: [{ id: 1, name: "Viber 8x8" }],
    list: [],
    total: 0,
    collection: "",

    loading: false,
    query: DATA_QUERY,
  };

  async componentWillMount() {
    this.props.fetchMenuAction("sms-logs", "sl-raw");

    this.setState({
      smsGatewayList: await getGatewayList(),
    });
  }

  getCollectionState = (col) => {
    return col.replace("_", "-");
  };

  fetchData = async (payload) => {
    this.setState({
      loading: true,
    });

    const dataSoruce = await getRawLogs(payload);

    this.setState({
      list: dataSoruce.data || [],
      total: dataSoruce.total_rows || 0,
      loading: false,
    });
  };

  handleSearchSubmit = (data) => {
    if (!!!data) {
      return;
    }

    const col = this.getCollectionState(data["collection"]);

    this.setState({
      query: { ...data, collection: col },
      collection: col,
    });

    return this.fetchData(data);
  };

  onChangePage = (page) => {
    this.setState({
      query: { ...this.state.query, page },
    });

    return this.fetchData({ ...this.state.query, page });
  };

  handleOnResetState = () => {
    this.setState({
      list: [],
      query: DATA_QUERY,
      collection: "",
      total: 0,
    });
  };

  handleOnChangeCollection = (col) => {
    //  change gatewayList when col is viber;
    if (col === Constant.TABLE_SMS_LOGS.VIBER_CAM) {
      this.setState({
        gatewayList: this.state.viberGatewayList,
      });

      return;
    }

    this.setState({
      gatewayList: this.state.smsGatewayList,
    });
  };

  renderExpendedInfo = (record) => {
    if (!!!record || this.state.collection === "") {
      return;
    }

    const temp = {};

    const maps = MAPKEY_FORM_VALUE[this.state.collection];
    if (!!!maps) {
      return;
    }

    for (const key of Object.keys(record)) {
      const mappedKey = Object.keys(maps).find((i) => maps[i] === key);
      if (!!!mappedKey) {
        temp[key] = record[key];
        continue;
      }

      temp[mappedKey] = record[key];
    }

    return JSON.stringify(temp, null, 5);
  };

  render() {
    const propsTable = {
      bordered: true,
      className: "my-table",
      columns: column(this.state.collection, this.state.gatewayList),
      dataSource: this.state.list,
      rowKey: "id",
      loading: this.state.loading,
      expandedRowRender: (record) => (
        <pre style={{ margin: "8px" }}>{this.renderExpendedInfo(record)}</pre>
      ),
      pagination: {
        pageSize: this.state.query.limit,
        total: this.state.total,
        current: this.state.query.page,
        onChange: this.onChangePage,
        size: "small",
      },
      size: "small",
      scroll: {
        x: 1500,
      },
    };

    return (
      <Layout className="my-layout">
        <Content
          style={{
            background: "#fff",
            padding: 24,
            margin: "16px 0",
            minHeight: 300,
          }}
        >
          <h2>Transaction Logs (Raw Mode)</h2>
          <p className="header-desc">บันทึกการใช้งาน</p>

          <Row className="utility-bar">
            <Col span={24}>
              <SearchRawForm
                cb={this.handleSearchSubmit}
                gateway={this.state.gatewayList}
                reset={this.handleOnResetState}
                onChangeCol={this.handleOnChangeCollection}
              />
            </Col>
          </Row>

          <Table {...propsTable} />
          <div className="mt-2 tag-info">
            <div className="tag-info-container">
              <Tag>In-progress</Tag> <div>Sending to operator</div>
            </div>
            <div className="tag-info-container">
              <Tag color="cyan">Sent</Tag> <div>Sent to operator</div>
            </div>
            <div className="tag-info-container">
              <Tag color="blue">Received</Tag>{" "}
              <div>Recipients received messages</div>
            </div>
            <div className="tag-info-container">
              <Tag color="red">Fail Operator</Tag>{" "}
              <div>Operator cannot sent SMS to recipients</div>
            </div>
            <div className="tag-info-container">
              <Tag color="red">Fail Gateway</Tag>{" "}
              <div>Cannot send SMS to operator</div>
            </div>
            <div className="tag-info-container">
              <Tag color="purple">Not-Received-A</Tag>{" "}
              <div>
                Recipients didn't receive messages as they informed Oper of not
                receiving SMS or ads. (Anti-Spam)
              </div>
            </div>
            <div className="tag-info-container">
              <Tag
                color="#CCD5DB"
                style={{ color: "#526069", border: "1px solid #526069" }}
              >
                Not Received-M
              </Tag>
              <div>
                Recipients didn't receive messages because of mobile phone
                problems. (no signal or insufficient storage)
              </div>
            </div>
            <div className="tag-info-container">
              <Tag
                color="#CCD5DB"
                style={{ color: "#526069", border: "1px solid #526069" }}
              >
                Blacklist
              </Tag>
              <div>Recipient informed to not received messages.</div>
            </div>
          </div>
        </Content>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(null, mapDispatchToProps)(SlRawLog);



// WEBPACK FOOTER //
// ./src/containers/SlRawLogs/index.js